/* eslint-disable react/no-danger-with-children */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from "react-router-dom";
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { XSquare } from 'react-bootstrap-icons';
import { Badge, Form, Modal, Button, Table, Spinner, Alert } from 'react-bootstrap';
import Axios from 'axios';
import Input from './common/Input';
import ImageUploader from './common/UploadImage';


const Client = (props) => {
    const history = useHistory();


    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const [name, setName] = useState('');
    const [contactName, setContactName] = useState('');
    const [tag, setTag] = useState('');
    const [loc, setLOC] = useState('');
    const [email, setEmail] = useState('');
    const [contact1, setContact1] = useState('');
    const [contact2, setContact2] = useState();
    const [contact, setContact] = useState();
    const [address, setAddress] = useState();
    const [description, setDescription] = useState();

    const [pincode, setPincode] = useState();

    const [localArea, setLocalArea] = useState('');

    const [stateId, setStateId] = useState('');
    const [jDate, setJDate] = useState('');
    const [districtId, setDistrictId] = useState('');
    const [category, setCategory] = useState('');
    const [countryId, setCountryId] = useState('');
    const [erpBranchid, setErpBranchid] = useState('');
    const [isCollege, setIsCollege] = useState('no');
    const [hasImages, setHasImages] = useState(false);
    const [hideMenu, setHideMenu] = useState('no');
    const [hideFooter, setHideFooter] = useState('no');
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);

    const [status, setStatus] = useState('');
    const [siteUrl, setSiteURL] = useState('');
    const [nationality, setNationality] = useState('Indian');
    const [sCategory, setSCategory] = useState('');
    const [organization, setOrganization] = useState('');
    const [designation, setDesignation] = useState('');
    const [accomodation, setAccomodation] = useState('yes');
    const [presenting, setPresenting] = useState('yes');
    const [role, setRole] = useState('User');
    const [paymentConfirmed, setPaymentConfirmed] = useState('no');
    const [abstractApproved, setAbstractApproved] = useState('no');

    const [yesNoOptions] = useState([{ name: 'Yes', value: 'yes' }, { name: 'No', value: 'no' }]);
    const [sRoleOptions] = useState(coreContext.applicantCategories);

    const [presentingOptions] = useState([{ name: 'Select One', value: '' }, { name: 'Invited Talk', value: 'Invited Talk' }, { name: 'Contributed Talk', value: 'Contributed Talk' }, { name: 'Poster Presentation', value: 'Poster Presentation' },]);

    const [roleOptions] = useState([{ name: 'User', value: 'User' }, { name: 'Moderator', value: 'Moderator' }, { name: 'Admin', value: 'Admin' }]);

    // Pay Now Modal State
    const [showPayModal, setShowPayModal] = useState(false);
    const [payAmount, setPayAmount] = useState('');
    const [payTransactionId, setPayTransactionId] = useState('');
    const [payDate, setPayDate] = useState(new Date().toISOString().split('T')[0]);
    const [payComments, setPayComments] = useState('Payment for Vyavastha Shulk');
    const [activeSahyogEvents, setActiveSahyogEvents] = useState([]);
    const [selectedSahyogEventId, setSelectedSahyogEventId] = useState('0');
    const [payLoading, setPayLoading] = useState(false);
    const [payStatusMessage, setPayStatusMessage] = useState('');
    const [payStatusType, setPayStatusType] = useState('info');

    // See Contributions Modal State
    const [showContribModal, setShowContribModal] = useState(false);
    const [contribLoading, setContribLoading] = useState(false);
    const [userContributions, setUserContributions] = useState([]);
    const [userRenewals, setUserRenewals] = useState([]);


    //useEffect(setClient(coreContext.client), [client]);

    const fetchClient = () => {

        //this.props.match.params.id //accessing param
        // console.log('paramas', props.match.params.id);
        //console.log('paramas', props.location);
        coreContext.fetchClient(props.location, authContext.ownerId);
        coreContext.fetchJnv(props.match.params.id);
    }

    useEffect(fetchClient, []);


    const loadLoactionOptions = () => {
        coreContext.fetchCountries();
        if (coreContext.client.countryId)
            coreContext.fetchStates(coreContext.client.countryId);
        if (coreContext.client.stateId)
            coreContext.fetchDistricts(coreContext.client.countryId, coreContext.client.stateId);
        if (coreContext.client.id)
            coreContext.fetchLocalAreas(coreContext.client.id);
        else history.push('/applicants');
    }



    const populateClient = () => {
        //  console.log(coreContext.jnv);
        setName(coreContext.client.item_name);
        setContactName(coreContext.client.item_contact_person);
        setTag(coreContext.client.item_tag);
        setLOC(coreContext.client.item_loc);
        setEmail(coreContext.client.item_email);
        setErpBranchid(coreContext.client.erp_branchid);
        setIsCollege(coreContext.client.is_college);
        setContact1(coreContext.client.item_mobile_1);
        setContact2(coreContext.client.item_mobile_2);
        setContact(coreContext.client.item_contact);
        setAddress(coreContext.client.item_address);
        setDescription(coreContext.client.item_description);
        setPincode(coreContext.client.item_pincode);
        setLocalArea(coreContext.client.areaId);
        setStateId(coreContext.client.stateId);
        setDistrictId(coreContext.client.districtId);
        setCategory(coreContext.client.categoryId);
        setSCategory(coreContext.client.smst_category);
        setCountryId(coreContext.client.countryId);
        // if(coreContext.client.enroll_today_image)
        setVideos([coreContext.client.enroll_today_image]);
        // else window.location.href = '/applicant';
        //  if(coreContext.client.register_now_image)
        setImages([coreContext.client.register_now_image]);
        // else window.location.href = '/applicant';
        setStatus(coreContext.client.item_status);
        setSiteURL(coreContext.client.site_url);
        setHideMenu(coreContext.client.hide_menu);
        setHideFooter(coreContext.client.hide_footer);

        setNationality(coreContext.client.smst_nationality);
        //  fetchCategory();
        if (coreContext.jnv)
            setOrganization(coreContext.jnv.district + ' ' + coreContext.jnv.address);
        setDesignation(coreContext.client.smst_designation);
        setAccomodation(coreContext.client.smst_accomodation);
        setPresenting(coreContext.client.smst_presenting);
        setRole(coreContext.client.smst_designation);
        setPaymentConfirmed(coreContext.client.smst_booking_confirmed);
        setAbstractApproved(coreContext.client.smst_abstract_accepted);
        setJDate(coreContext.client.membership_start_date);

    }

    const fetchCategory = () => {
        const v = sRoleOptions.filter(obj => obj.value == coreContext.client.categoryId);
        if (v[0])
            setSCategory(v[0].name);
    }

    useEffect(loadLoactionOptions, [coreContext.client]);
    useEffect(populateClient, [coreContext.client]);

    const renderImages = () => {
        if (images.length > 0)
            return images.map(image => <a rel="noopener noreferrer" target="_blank" href={`http://${image}`}><img style={{ padding: 5 }} className="img-fluid" src={image.includes('.pdf') ? 'https://node-websites.siddhantait.com/images/pdfimage.png' : `http://${image}`} alt='Abstract not found' /></a>)
    }

    const renderVideos = () => {
        //console.log(coreContext.client);
        if (videos.length > 0)
            return videos.map(image => <a rel="noopener noreferrer" target="_blank" href={`http://${image}`}><img style={{ padding: 5 }} className="img-fluid" src={image.includes('.pdf') ? 'https://node-websites.siddhantait.com/images/pdfimage.png' : `http://${image}`} alt='Payment receipt not found' /></a>)
    }


    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur'
    });


    const clientEditHandler = (data) => {
        coreContext.editClient(coreContext.client.id, authContext.ownerId, paymentConfirmed, abstractApproved, sCategory, role, jDate, organization);

    }


    const onEmailChangedHandler = (e) => {
        setEmail(e.target.value);
    }

    const onContact1Handler = (e) => {
        setContact1(e.target.value);
    }


    const onNameChangedHandler = (e) => {
        setName(e.target.value);
    }

    // Handlers for Pay Now
    const handleOpenPayModal = () => {
        setPayTransactionId('');
        setPayDate(new Date().toISOString().split('T')[0]);
        setPayComments('Payment for Vyavastha Shulk');
        setSelectedSahyogEventId('0');
        setPayStatusMessage('');
        Axios.get('/self', { params: { itemId: authContext.ownerId } }).then(res => {
            if (res.data && res.data.client && res.data.client.membership_fees) {
                setPayAmount(res.data.client.membership_fees);
            } else {
                setPayAmount('1000');
            }
        }).catch(() => {
            setPayAmount('1000');
        });

        // Fetch active sahyog events
        Axios.get('/jnv-sahyog-events', { params: { ownerId: authContext.ownerId, status: 'active' } })
            .then(res => {
                if (res.data && res.data.events) {
                    setActiveSahyogEvents(res.data.events);
                }
            })
            .catch(err => console.error('Error fetching active sahyog events:', err));

        setShowPayModal(true);
    };

    const handleClosePayModal = () => {
        setShowPayModal(false);
        setPayStatusMessage('');
    };

    const handleEventSelectionChange = (e) => {
        const val = e.target.value;
        setSelectedSahyogEventId(val);
        if (val === '0' || val === 0) {
            setPayComments('Payment for Vyavastha Shulk');
        } else {
            const found = activeSahyogEvents.find(item => String(item.id) === String(val));
            if (found) {
                setPayComments(`Contribution for Sahyog Event: ${found.item_name}`);
            } else {
                setPayComments(`Contribution for Sahyog Event #${val}`);
            }
        }
    };

    const handlePaySubmit = (e) => {
        if (e) e.preventDefault();
        if (!payAmount || Number(payAmount) <= 0) {
            setPayStatusType('danger');
            setPayStatusMessage('Please enter a valid amount.');
            return;
        }
        if (!payTransactionId.trim()) {
            setPayStatusType('danger');
            setPayStatusMessage('Please enter a transaction ID.');
            return;
        }
        if (!payDate) {
            setPayStatusType('danger');
            setPayStatusMessage('Please select a payment date.');
            return;
        }

        setPayLoading(true);
        setPayStatusMessage('Recording payment, please wait...');
        setPayStatusType('info');

        const targetId = coreContext.client.id || props.match.params.id;
        const isSahyogEvent = selectedSahyogEventId !== '0' && selectedSahyogEventId !== 0 && String(selectedSahyogEventId) !== '0';
        const eventIdToSubmit = isSahyogEvent ? selectedSahyogEventId : 0;

        Axios.post('/record-event-payment', {
            itemId: targetId,
            eventId: eventIdToSubmit,
            amount: payAmount,
            paymentId: payTransactionId.trim(),
            comment: payComments || (isSahyogEvent ? 'Contribution for Sahyog Event' : 'Payment for Vyavastha Shulk'),
            createdAt: payDate,
            date: payDate,
        }).then(response => {
            if (!isSahyogEvent) {
                Axios.post('update-membership-date', {
                    itemId: targetId,
                    ownerId: authContext.ownerId
                }).catch(err => console.error('Error updating membership date:', err));

                setPaymentConfirmed('yes');
                coreContext.editClient(targetId, authContext.ownerId, 'yes', abstractApproved, sCategory, role, jDate, organization);
            }

            setPayLoading(false);
            setPayStatusType('success');
            setPayStatusMessage(isSahyogEvent ? 'Sahyog Event contribution recorded successfully!' : 'Payment recorded successfully!');

            fetchClient();

            setTimeout(() => {
                setShowPayModal(false);
                setPayStatusMessage('');
            }, 2000);
        }).catch(err => {
            setPayLoading(false);
            setPayStatusType('danger');
            const errMsg = (err.response && err.response.data && (err.response.data.message || (err.response.data.data && err.response.data.data[0] && err.response.data.data[0].msg))) || 'Error recording payment. Please try again.';
            setPayStatusMessage(errMsg);
        });
    };

    // Handlers for See Contributions
    const handleOpenContribModal = () => {
        setShowContribModal(true);
        setContribLoading(true);
        const targetId = coreContext.client.id || props.match.params.id;

        const p1 = Axios.get('/jnv-sahyog-events-my-contributions', { params: { itemId: targetId } });
        const p2 = Axios.get('/my-renewals', { params: { itemId: targetId } });

        Promise.all([p1, p2]).then(([resContrib, resRenewals]) => {
            if (resContrib.data && resContrib.data.events) {
                const eids = [];
                const events = [];
                resContrib.data.events.forEach(event => {
                    if (!eids.includes(event.id)) {
                        eids.push(event.id);
                        events.push(event);
                    }
                });
                setUserContributions(events);
            } else {
                setUserContributions([]);
            }

            if (resRenewals.data && resRenewals.data.events) {
                setUserRenewals(resRenewals.data.events);
            } else {
                setUserRenewals([]);
            }
            setContribLoading(false);
        }).catch(err => {
            console.error('Error fetching contributions/renewals:', err);
            setContribLoading(false);
        });
    };

    const handleCloseContribModal = () => {
        setShowContribModal(false);
    };

    const getTotalContributionsAmount = () => {
        let total = 0;
        userContributions.forEach(item => {
            if (item.amount) total += parseInt(item.amount, 10) || 0;
        });
        return total;
    };

    const getTotalRenewalsAmount = () => {
        let total = 0;
        userRenewals.forEach(item => {
            if (item.amount) total += parseInt(item.amount, 10) || 0;
        });
        return total;
    };



    return (<div className='container'>
        <div className="row" >
            <div className="col-md-6">
                <div className="card">
                    <div className="card-title mx-auto"><h3><Badge variant="success">Modify Applicant Details</Badge></h3></div>
                    <div className="card-body">
                        <Form autoComplete='off' onSubmit={handleSubmit(clientEditHandler)} noValidate>
                            <Input label='Name' readOnly={true} value={name} name='name' minLength={5} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Name' onChange={onNameChangedHandler} />

                            <Input label='Email' name='email' value={email} required={true} register={register} errors={errors} elementType='text' readOnly={true} minLength={5} maxLength={55} pattern={/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/} placeholder='Enter Email' onChange={onEmailChangedHandler} />

                            <div className="row" >
                                <div className="col-md-8">

                                    {/* <Input label='Category' readOnly={true} value={sCategory} name='category' minLength={1} maxLength={55} required={true} register={register} errors={errors} elementType='text' placeholder='Category' onChange={(e) => setSCategory(e.target.value)} /> */}
                                    {authContext.item.smst_designation === 'Admin' ? <Input label='Role' name='role' value={role} required={true} register={register} errors={errors} elementType='select' options={roleOptions} onChange={(e) => setRole(e.target.value)} /> : ''}

                                    <Input label='Category' name='category' value={sCategory} required={true} register={register} errors={errors} elementType='select' options={sRoleOptions} onChange={(e) => setSCategory(e.target.value)} />

                                </div>
                                <div className="col-md-4 d-flex flex-column align-items-start">
                                    <Link className="btn btn-link px-0" to={`/reset-password/${coreContext.client.item_email}`}>Reset Password</Link>
                                    <Link className="btn btn-link px-0" to={`/applicant-jnv-details/${coreContext.client.id}`}>{authContext.item.smst_designation === 'Admin' ? 'Full Profile' : ''}</Link>
                                    <Link className="btn btn-primary btn-sm mb-2 w-100" to={`/list-for-sahyog/${coreContext.client.id}`}>List for Sahyog</Link>

                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm mb-2 w-100"
                                        onClick={handleOpenPayModal}
                                    >
                                        Pay Now
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-info btn-sm mb-2 w-100 text-white"
                                        onClick={handleOpenContribModal}
                                    >
                                        See Contributions
                                    </button>
                                </div>
                            </div>



                            <Input label='Navodaya Details' name='organization' minLength={2} maxLength={255} required={true} value={organization} register={register} errors={errors} elementType='text' placeholder='Navodaya Details' onChange={(e) => setOrganization(e.target.value)} />



                            <Input label='Phone' name='contact1' value={contact} minLength={6} maxLength={15} required={true} readOnly={true} register={register} errors={errors} elementType='text' placeholder='Enter Phone no.' onChange={onContact1Handler} />


                            <Input label='Payment Confirmed' name='pconfirmed' value={paymentConfirmed} required={true} register={register} errors={errors} elementType='select' options={yesNoOptions} onChange={(e) => setPaymentConfirmed(e.target.value)} />

                            <Input label='Abstract Approved' name='aApproved' value={abstractApproved} required={true} register={register} errors={errors} elementType='select' options={yesNoOptions} onChange={(e) => setAbstractApproved(e.target.value)} />

                            <Input label='Joining Confirmation Date' value={jDate} name='jdate' minLength={10} maxLength={10} required={false} register={register} errors={errors} elementType='date' placeholder='Joining Date in current Jnv' onChange={(e) => setJDate(e.target.value)} />

                            <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                            <Input variant='danger' label={coreContext.message} elementType='label' />
                        </Form>
                    </div>
                </div>
            </div>
            <div className="col-md-6" style={{ maxHeight: '500px', overflowY: 'auto', position: 'sticky', top: '50px' }}>
                <div className="card">
                    <div className="card-header">Certificate</div>
                    <div className="card-body">
                        <div className="row">
                            {renderImages()}
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card">
                        <div className="card-header">Payment Receipt</div>
                        <div className="card-body">
                            <div className="row">
                                {renderVideos()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Pay Now Modal */}
        <Modal show={showPayModal} onHide={handleClosePayModal} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Record Payment
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3 p-2 bg-light rounded border">
                    <div><strong>Applicant:</strong> {name || coreContext.client.item_name}</div>
                    <div className="text-muted small"><strong>Email:</strong> {email || coreContext.client.item_email}</div>
                </div>

                {payStatusMessage && (
                    <Alert variant={payStatusType} className="py-2">
                        {payStatusMessage}
                    </Alert>
                )}

                <Form onSubmit={handlePaySubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Payment Towards / Sahyog Event</strong></Form.Label>
                        <select
                            className="form-select form-control"
                            value={selectedSahyogEventId}
                            onChange={handleEventSelectionChange}
                        >
                            <option value="0">Vyavastha Shulk (Membership Fees)</option>
                            {activeSahyogEvents && activeSahyogEvents.length > 0 && (
                                <optgroup label="Active Sahyog Events">
                                    {activeSahyogEvents.map(se => (
                                        <option key={se.id} value={se.id}>
                                            Sahyog: {se.item_name} ({se.district || 'General'})
                                        </option>
                                    ))}
                                </optgroup>
                            )}
                        </select>
                        <Form.Text className="text-muted small">
                            {selectedSahyogEventId === '0' || selectedSahyogEventId === 0
                                ? 'Payment will be credited towards Annual Vyavastha Shulk (Membership Fee).'
                                : 'Payment will be credited as a contribution towards this Sahyog Event.'}
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label><strong>Amount (Rs.) <span className="text-danger">*</span></strong></Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter amount"
                            value={payAmount}
                            onChange={(e) => setPayAmount(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label><strong>Transaction ID / Ref <span className="text-danger">*</span></strong></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter transaction/UTR/payment ID"
                            value={payTransactionId}
                            onChange={(e) => setPayTransactionId(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label><strong>Payment Date <span className="text-danger">*</span></strong></Form.Label>
                        <Form.Control
                            type="date"
                            value={payDate}
                            onChange={(e) => setPayDate(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label><strong>Comments / Purpose</strong></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Payment for Vyavastha Shulk"
                            value={payComments}
                            onChange={(e) => setPayComments(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClosePayModal} disabled={payLoading}>
                    Cancel
                </Button>
                <Button variant="success" onClick={handlePaySubmit} disabled={payLoading}>
                    {payLoading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Recording...
                        </>
                    ) : 'Submit Payment'}
                </Button>
            </Modal.Footer>
        </Modal>

        {/* See Contributions Modal */}
        <Modal show={showContribModal} onHide={handleCloseContribModal} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Contributions & Renewals
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="mb-3 p-2 bg-light rounded border d-flex justify-content-between align-items-center">
                    <div>
                        <strong>Applicant:</strong> {name || coreContext.client.item_name} ({email || coreContext.client.item_email})
                    </div>
                    <Badge variant="primary" bg="primary">{sCategory || 'Member'}</Badge>
                </div>

                {contribLoading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" variant="primary" />
                        <div className="mt-2 text-muted">Loading contribution records...</div>
                    </div>
                ) : (
                    <>
                        <h5 className="mt-2 mb-2 text-primary border-bottom pb-1">Sahyog Event Contributions</h5>
                        <Table responsive striped bordered hover size="sm">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Event / Details</th>
                                    <th>Payment Date</th>
                                    <th>Amount (Rs.)</th>
                                    <th>Payment ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userContributions && userContributions.length > 0 ? (
                                    userContributions.map((item, idx) => (
                                        <tr key={item.id || idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.comments || item.item_name || 'Contribution'}</td>
                                            <td>{item.createdAt ? new Date(item.createdAt).toDateString() : '-'}</td>
                                            <td><strong>₹{item.amount}</strong></td>
                                            <td><code className="text-dark">{item.paymentUrl || '-'}</code></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-3">
                                            No Sahyog contributions found for this user.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {userContributions && userContributions.length > 0 && (
                                <tfoot>
                                    <tr className="table-secondary">
                                        <th colSpan="3">Total Event Contributions</th>
                                        <th colSpan="2" className="text-success">₹{getTotalContributionsAmount()}</th>
                                    </tr>
                                </tfoot>
                            )}
                        </Table>

                        <h5 className="mt-4 mb-2 text-primary border-bottom pb-1">Membership Renewals (Vyavastha Shulk)</h5>
                        <Table responsive striped bordered hover size="sm">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Event / Description</th>
                                    <th>Payment Date</th>
                                    <th>Amount (Rs.)</th>
                                    <th>Payment ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userRenewals && userRenewals.length > 0 ? (
                                    userRenewals.map((item, idx) => (
                                        <tr key={item.id || idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.comments || 'Payment for membership fees'}</td>
                                            <td>{item.createdAt ? new Date(item.createdAt).toDateString() : '-'}</td>
                                            <td><strong>₹{item.amount}</strong></td>
                                            <td><code className="text-dark">{item.paymentUrl || '-'}</code></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-3">
                                            No renewal records found for this user.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {userRenewals && userRenewals.length > 0 && (
                                <tfoot>
                                    <tr className="table-secondary">
                                        <th colSpan="3">Total Renewal Payments</th>
                                        <th colSpan="2" className="text-success">₹{getTotalRenewalsAmount()}</th>
                                    </tr>
                                </tfoot>
                            )}
                        </Table>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseContribModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    </div>);
}


export { Client };